<template>
  <!-- {{ item }} -->
  <div
    class="px-2.5 py-1.5 my-2 mr-2 rounded-lg border-1 cursor-pointer transition-all hover:shadow-md border-gray-300 hover:border-purple-300 bg-white "
>
    <div class="flex justify-between items-center w-full mb-2">
      <p class="m-0 text-[#9C9BBF] font-roboto text-base">
        {{ $helper.formatDateTime(item.sale_date) }}
      </p>
      <img v-if="item.partner_company_logo" :src="item.partner_company_logo" alt="Partner Company Logo" class="w-12 h-12 object-contain max-h-10">
    </div>
    <div class="relative mobile:flex-col tablet:flex tablet:flex-row justify-between gap-2">
      <div class="w-10">
        <span
          class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block"
>ID:</span>
        <p class="m-0 font-roboto text-base font-400">
          {{ item.id }}
        </p>
      </div>
      <div class="w-28 pr-[10px] largeDesktop:w-20 largeDesktop:pr-0">
        <span class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block">Agreement ID:</span>
        <p class="m-0 font-roboto text-base font-400">
          {{ $helper.isEmpty(item.agreement_id) ? '-' : item.agreement_id }}
        </p>
      </div>
      <div class="w-40">
        <span
          class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block"
>Consumer:</span>
        <p class="m-0 font-roboto text-base font-400">
          {{ $helper.isEmpty(item.consumer_name) ? '-' : item.consumer_name }}
        </p>
      </div>
      <div class="w-68 largeDesktop:w-72 relative group">
        <span class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block">
          Plan:
        </span>
        <!-- Show full name directly on mobile -->
        <p class="m-0 font-roboto text-base font-400 block tablet:hidden">
          {{ item.plan_name }}
        </p>
        <!-- Short name + tooltip on tablet and above -->
        <p class="m-0 font-roboto text-base font-400 relative hidden tablet:block">
          {{ getShortPlanName(item.plan_name) }}
          <span
class="opacity-0 group-hover:!opacity-100 transition-opacity duration-300 max-w-[250px]
             absolute left-0 top-full mt-1 z-10 bg-white text-black text-sm
             px-2 py-1 rounded shadow-xl border border-gray-300"
>
            {{ item.plan_name }}
          </span>
        </p>
      </div>
      <div class="w-20">
        <span
          class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block"
>Trade:</span>
        <p class="m-0 font-roboto text-base font-400">
          {{ $helper.isEmpty(item.trade_name) ? '-' : item.trade_name }}
        </p>
      </div>
      <div class="w-20">
        <span
          class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block"
>Qty:</span>
        <p class="m-0 font-roboto text-base font-400">
          {{ $helper.isEmpty(item.quantity) ? '-' : item.quantity }}
        </p>
      </div>
      <div class="w-32">
        <span class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block">Plan
          Amount:</span>
        <p class="m-0 font-roboto text-base font-400">
          ${{ $helper.isEmpty(item.total_amount) ? '-' : $helper.formatAmount(item.total_amount) }}
          <span class="mobile:text-base tablet:text-base">/{{
            item.payment_term_slug === 'yearly' ? 'yr' : 'mo'
          }}</span>
        </p>
      </div>
      <div class="w-32">
        <span
          class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block"
>Activation
          Date:</span>
        <p class="m-0 font-roboto text-base font-400">
          {{ $helper.isEmpty(item.activation_date) ? '-' : $helper.formatDateTime(item.activation_date) }}
        </p>
      </div>
      <div class="mobile:absolute mobile:top-3 mobile:right-2 tablet:relative tablet:top-0 tablet:right-0">
        <span
          class="mobile:hidden tablet:block text-base text-center text-[#EA8A8A] font-roboto tablet:min-h-[50px] desktop:!min-h-[auto] inline-block"
>Status</span>
        <img :src="getStatusImage(item.status_slug)" alt="status-icon" class="w-5 h-5 mx-auto">
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  props: ["item"],
  methods: {
    getShortPlanName(name) {
      if (this.$helper.isEmpty(name)) return '-';
      return name.length > 30 ? name.substring(0, 30) + '...' : name;
    },
    getStatusImage(status) {
      switch (status) {
        case 'pending':
          return require('@/assets/images/pending-status.png');
        case 'approved':
          return require('@/assets/images/approved-green-icon.png');
        case 'rejected':
          return require('@/assets/images/reject-status.png');
        default:
          return require('@/assets/images/pending-status.png');
      }
    }
  }
};
</script>